import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

type ImportReviewDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  disableClose?: boolean;
  children: React.ReactNode;
};

export const ImportReviewDialog: React.FC<ImportReviewDialogProps> = ({
  open,
  onOpenChange,
  title,
  disableClose = false,
  children
}) => {
  const handleOpenChange = (nextOpen: boolean) => {
    if (disableClose && !nextOpen) return;
    onOpenChange(nextOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        className="bg-white p-3 text-xs"
        contentWidth="90%"
        contentMaxWidth="90%"
        contentHeight="auto"
      >
        <DialogHeader className="space-y-1 text-left pr-8">
          <DialogTitle className="text-sm font-semibold text-gray-900">{title}</DialogTitle>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default ImportReviewDialog;
